import PageHead from "../Head";
import Context from "@/context/Context";
import FindMyTickets from "@/my_components/_Events/FindMyTickets";

// Deliberately NO HeaderContainer/Footer -- a focused, full-screen split flow (matching
// Eventbrite's own /signin/signup?referrer=/mytickets page), not a page the visitor browses
// around from. The panel's own logo links back to /events.
const FindMyTicketsPage = () => {
  return (
      <Context>
        <PageHead title="Find My Tickets | SmartTech Academy" description="Look up every event ticket booked with your email -- no account needed." />

        <FindMyTickets />
      </Context>
  );
};

export default FindMyTicketsPage;
